export default {
  eprPages: {
    list: {
      paymentRequestFailed: "Payment request failed",
      noCountry: "No country",
      actions: "Actions",
      downloadPaymentMemo: "Download payment memo file",
    },
    banners: {
      transactionsUpdated:
        "{{website}} transaction data for the period from {{from}} to {{to}} has been successfully updated",
      transactionsUpgrading:
        "{{website}} transaction data for the period from {{from}} to {{to}} is being updated",
    },
    filters: {
      dateRange: "Date range",
      countryPlaceholder: "Country",
      countryFilter: "Country filter",
      noCountriesFound: "No countries found",
    },
    statuses: {
      new: "New",
      processing: "Processing",
      submitted: "Submitted",
      declined: "Declined",
      pending: "Pending",
      draft: "Draft",
      ready: "Ready",
    },
    modals: {
      deleteDescription: "Do you want to delete {{name}} for {{country}} {{year}}?",
      dataCorrupted: "Data is corrupted. Please contact support.",
    },
    payment: {
      noPaymentData: "No payment data found.",
      checkingStatus: "Checking subscription and add-ons status... ({{attempt}}/{{total}})",
      unexpectedError:
        "An unexpected error occurred. Please try again later or contact support if the issue persists.",
      activated: "Your subscription has been activated. Thank you for your payment!",
      failed:
        "We couldn't process your payment. Please check your card details or try a different payment method.",
      cancelled: "Payment was cancelled. You can try again when ready.",
      processing: "Payment is still processing. Please wait...",
      genericError: "Error",
      creditConfirmationError: "Could not open the credit confirmation for this declaration.",
    },
    periodTypes: {
      year: "year",
      quarter: "quarter",
      month: "month",
      period: "period",
      "bi-annual": "bi-annual",
      "bi-monthly": "bi-monthly",
      biAnnualFirst: "bi-annual (Jan-Jun)",
      biAnnualSecond: "bi-annual (Jul-Dec)",
    },
    wizard: {
      subcategoryN: "Subcategory {{number}}",
      amountN: "Amount {{number}}",
      unitTypeN: "Unit type {{number}}",
      state: "State",
      province: "Province",
      enterRevenueExclVat: "Enter your revenue excluding VAT:",
      enterProductDescription: "Enter your product description:",
      enterNumberOfCsu: "Enter your number of CSU:",
      noItemsTitle: "There are no items",
      noItemsDescription: "To see items, you need to add them first",
      addItems: "Add items",
      editItemWithCode: "Edit item with code: {{code}}",
      declarationTitle: "<bold>{{type}}</bold> for {{period}} for <bold>{{country}}</bold>",
      uploadSuccessTitle: "Your data has been uploaded successfully.",
      proceedToQuantity:
        "Please proceed to the <bold>Quantity</bold> step to review and confirm your information.",
      choosePackagingGroups: "Please choose your packaging groups:",
      manualUploadData: "Manual Upload Data",
      unitsSuffix: "(units)",
      selectFileFirst: "Please select a file first",
      uploadSuccess: "File uploaded successfully",
      uploadFailed: "Upload failed",
      uploadError: "An error occurred during file upload",
      errorInLine: "Error in line {{line}}: {{error}}",
      errorColumn: "Column: {{column}}",
      errorValue: "Value: {{value}}",
      expectedValues: "Expected values: {{values}}",
    },
    preview: {
      title: "Preview",
      name: "Name",
      value: "Value",
      kg: "Kg",
      totalKg: "Total kg",
      productDescription: "Product description",
      numberOfCsu: "Number of CSU",
      recyclate: "Recyclate",
      units: "Units",
      category: "Category",
      number: "Number",
      product: "Product",
      productTypology: "Product typology",
      categoryLabel: "Category:",
      valueLabel: "Value:",
      productLabel: "Product:",
      dataCorruptedInvalid:
        "Data is corrupted. The server returned invalid data structure. Please contact support.",
      countryValue: "Country: {{value}}",
      currencyValue: "Currency: {{value}}",
      periodValue: "Period: {{period}} {{periodType}} {{year}}",
      totalAmountValue: "Total amount: {{value}}",
    },
    transactions: {
      transactionId: "Transaction ID",
      date: "Date",
      eprCategory: "EPR category",
      eprSubcategory1: "EPR subcategory 1",
      country: "Country",
      quantity: "Quantity",
      unitMeasurement: "Unit of measurement",
      kg: "Kg",
      actions: "Actions",
      delete: "Delete",
      restore: "Restore",
      void: "Void",
      addTransaction: "Add transaction",
      uploadHint: "Here you can upload a file with transactions.",
    },
  },
};
